import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import DatePicker from "react-datepicker";
import { orderData } from "../pre-built/orders/OrderData";
import axios from "axios";
import {useHistory} from 'react-router-dom';
import { API_URL } from "../../constent";

import {
  Block,
  BlockHeadContent,
  BlockTitle,
  BlockBetween,
  BlockHead,
  DataTableHead,
  DataTableItem,
  DataTableRow,
  Icon,
  TooltipComponent,
  PaginationComponent,
  PreviewAltCard,
  Row,
  Col,
  RSelect,
} from "../../components/Component";
import { getDateStructured } from "../../utils/Utils";
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem, Button, Modal, ModalBody } from "reactstrap";
import { useForm } from "react-hook-form";

const Teamlist = () => {

  const { errors, register, handleSubmit } = useForm();
  
  const [data, setData] = useState([]);
  const [smOption, setSmOption] = useState(false);
  const [loading, setLoading] = useState(false);
  const [getload, getLoading] = useState(false);
  const [formData, setFormData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [stage, setStage] = useState([]);
  const [selectedStages, setSelectedStages] = useState([]);
  const [edit, setEdit] = useState(0);

  const history = useHistory();

  const [view, setView] = useState({
    add: false,
    details: false,
  });
  const [onSearchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);

  var userData = JSON.parse(localStorage.getItem('userData'));
  const role = userData?.[0]?.role;


  // Changing state value when searching name
  useEffect(() => {
    if (onSearchText !== "") {
      const filteredObject = data.filter((item) => {
        // return item.fullname.includes(onSearchText);
        return item.fullname.toLowerCase().includes(onSearchText.toLowerCase())
      });
      setData(filteredObject);
    } else {
        axios.post(`${API_URL}getteamlist`).then((result)=>
        {
            console.log(result.data);
            setData(result.data);
            getLoading(false);
        })
        axios.post(`${API_URL}getstage`).then((result)=>
        {
            console.log(result.data);
            setStage(result.data);
        })

    }
  }, [onSearchText , refresh]);

  if (getload) {
    return(
       <>
         <p>Loading....</p>
       </>
    ) 
} 


  // toggle function to view order details
  const toggle = (type) => {
    setView({
      add: type === "add" ? true : false,
      details: type === "details" ? true : false,
    });
  };

  // selects all the order
  const selectorCheck = (e) => {
    let newData;
    newData = data.map((item) => {
      item.check = e.currentTarget.checked;
      return item;
    });
    setData([...newData]);
  };

  // selects one order
  const onSelectChange = (e, id) => {
    let newData = data;
    let index = newData.findIndex((item) => item.id === id);
    newData[index].check = e.currentTarget.checked;
    setData([...newData]);
  };

  
  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;


    if (checked) {
      // Add the selected value to the state after converting it to a number
      setSelectedStages([...selectedStages, Number(value)]);
    } else {
      // Remove the unselected value from the state
      setSelectedStages(selectedStages.filter((stage) => stage !== Number(value)));
    }
    
    console.log(selectedStages);

  };



 
  const onFormSubmit = (form) => {

    const { customer, email_id, phone_no, password, username } = form;

    const formdata = new FormData() 
    formdata.append('customer' , customer);
    formdata.append('email_id' , email_id);
    formdata.append('phone_no' , phone_no);
    formdata.append('stages' , selectedStages);
    formdata.append('password' , password);
    formdata.append('username' , username);
    formdata.append('useredit' , edit);

    setLoading(true);

    axios.post( `${API_URL}addteam`, formdata)
    .then((response)=>{
        console.log(response.data);
        if(response.data.status === 1){
            setLoading(false);
            setRefresh(true);
            onFormCancel();
            history.push('/team-list');
        }else{
            setLoading(false);
            alert(response.data.msg);
        }
    })
  };

  // function to load detail data
  const loadDetail = (id) => {
    let index = data.findIndex((item) => item.id === id);
    setFormData(data[index]);
  };

  // OnChange function to get the input data
  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // onChange function for searching name
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, details: false });
    setEdit(0);
  };

  // function to change to approve property for an item
  const markAsDelivered = (id) => {
    let newData = data;
    let index = newData.findIndex((item) => item.id === id);
    newData[index].status = "Delivered";
    setData([...newData]);
  };

  // function to delete a Order
  const deleteOrder = (id) => {

    axios.get(`${API_URL}deleteteam/${id}`).then((result)=>
    {
        console.log(result.data);
        setRefresh(true);
    })
  };

  const changestatus = (id,status) =>{
      axios.get(`${API_URL}changestatus_team/${id}/${status}`).then((result)=>
        {
            console.log(result.data);
            setRefresh(true);
        })
  }

  const editteam = (id) =>{
      axios.get(`${API_URL}editteam/${id}`).then((result)=>
        {
            console.log(result.data);
            toggle("add");
            setFormData({
              ...formData,
              customer: result.data[0]?.fullname || "",
              email_id: result.data[0]?.email || "",
              phone_no: result.data[0]?.phone || "",
              username: result.data[0]?.username || "",
              password: result.data[0]?.org_password || "",
            });

            setSelectedStages(result.data[0].stage.map(Number));
            setEdit(id);
            // setRefresh(true);
        })
  }


  

  // function to delete the seletected item
  const selectorDeleteOrder = () => {
    let newData;
    newData = data.filter((item) => item.check !== true);
    setData([...newData]);
  };

  // function to change the complete property of an item
  const selectorMarkAsDelivered = () => {
    let newData;
    newData = data.map((item) => {
      if (item.check === true) item.status = "Delivered";
      return item;
    });
    setData([...newData]);
  };

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);


  return (
    <React.Fragment>
      <Head title="Order Default"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle>Team List</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div className="toggle-expand-content" style={{ display: smOption ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    <li>
                      <div className="form-control-wrap">
                        <div className="form-icon form-icon-right">
                          <Icon name="search"></Icon>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          id="default-04"
                          placeholder="Search by User Name"
                          onChange={(e) => onFilterChange(e)}
                        />
                      </div>
                    </li>
                    <li className="nk-block-tools-opt">
                      <Button
                        className="toggle d-none d-md-inline-flex"
                        color="primary"
                        onClick={() => {
                          toggle("add");
                        }}
                      >
                        <Icon name="plus"></Icon>
                        <span>Add Team</span>
                      </Button>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="nk-tb-list is-separate is-medium mb-3">
            <DataTableHead className="nk-tb-item">
              {/* <DataTableRow className="nk-tb-col-check">
                <div className="custom-control custom-control-sm custom-checkbox notext">
                  <input
                    type="checkbox"
                    className="custom-control-input form-control"
                    id="pid-all"
                    onChange={(e) => selectorCheck(e)}
                  />
                  <label className="custom-control-label" htmlFor="pid-all"></label>
                </div>
              </DataTableRow> */}
              <DataTableRow>
                <span className="sub-text">User Name</span>
              </DataTableRow>
              <DataTableRow size="md">
                <span className="sub-text">Email</span>
              </DataTableRow>
              <DataTableRow>
                <span className="sub-text">Phone</span>
              </DataTableRow>
              <DataTableRow>
                <span className="sub-text">Username</span>
              </DataTableRow>
              <DataTableRow>
                <span className="sub-text">Password</span>
              </DataTableRow>
              <DataTableRow size="sm">
                <span className="sub-text">Status</span>
              </DataTableRow>
              {/* <DataTableRow size="md">
                <span className="sub-text">Stage</span>
              </DataTableRow> */}
              <DataTableRow className="text-right">
                <span className="sub-text">Action</span>
              </DataTableRow>

            </DataTableHead>

            {currentItems.length > 0
              ? currentItems.map((item) => (
                  <DataTableItem key={item.id}>
                    {/* <DataTableRow className="nk-tb-col-check">
                      <div className="custom-control custom-control-sm custom-checkbox notext">
                        <input
                          type="checkbox"
                          className="custom-control-input form-control"
                          defaultChecked={item.check}
                          id={item.id + "oId-all"}
                          key={Math.random()}
                          onChange={(e) => onSelectChange(e, item.id)}
                        />
                        <label className="custom-control-label" htmlFor={item.id + "oId-all"}></label>
                      </div>
                    </DataTableRow> */}
                    <DataTableRow>
                      {/* <a href="#id" onClick={(ev) => ev.preventDefault()}>
                        {item.fullname}
                      </a> */}
                      {item.fullname}
                    </DataTableRow>
                    <DataTableRow size="md">
                      <span>{item.email}</span>
                    </DataTableRow>
                    <DataTableRow size="sm">
                      <span>{item.phone}</span>
                    </DataTableRow>
                    <DataTableRow size="sm">
                      <span>{item.username}</span>
                    </DataTableRow>
                    <DataTableRow size="sm">
                      <span>{item.org_password}</span>
                    </DataTableRow>
                    <DataTableRow>
                      <span
                        className={`dot bg-${item.status === 1 ? "success" : "warning"} d-mb-none`}
                      ></span>
                      <span
                        className={`badge badge-sm badge-dot has-bg badge-${
                          item.status === 1 ? "success" : "warning"
                        } d-none d-mb-inline-flex`}
                      >
                        {item.status === 1 ? "Active" : "Inactive" }
                      </span>
                    </DataTableRow>
                    
                    {/* <DataTableRow>
                      <span className="tb-lead">{item.stage_labels}</span>
                    </DataTableRow> */}
                    
                    <DataTableRow className="nk-tb-col-tools">
                      <ul className="nk-tb-actions gx-1">
                
                        <li>
                          <UncontrolledDropdown>
                            <DropdownToggle tag="a" className="btn btn-icon dropdown-toggle btn-trigger">
                              <Icon name="more-h"></Icon>
                            </DropdownToggle>
                            <DropdownMenu right>
                              <ul className="link-list-opt no-bdr">
                                {
                                  role === 1 &&(
                                      <li>
                                        <DropdownItem
                                          tag="a"
                                          href="#dropdown"
                                          onClick={(ev) => {
                                            ev.preventDefault();
                                            deleteOrder(item.id);
                                          }}
                                        >
                                          <Icon name="trash"></Icon>
                                          <span>Delete</span>
                                        </DropdownItem>
                                      </li>
                                  )
                                }

                                <li>
                                  <DropdownItem
                                    tag="a"
                                    href="#dropdown"
                                    onClick={(ev) => {
                                      ev.preventDefault();
                                      changestatus(item.id , item.status);
                                    }}
                                  >
                                    <Icon name="check"></Icon>
                                    <span>{item.status === 1 ? "Inactive" : "Active" }</span>
                                  </DropdownItem>
                                </li>

                                <li>
                                  <DropdownItem
                                    tag="a"
                                    href="#dropdown"
                                    onClick={(ev) => {
                                      ev.preventDefault();
                                      editteam(item.id);
                                    }}
                                  >
                                    <Icon name="check"></Icon>
                                    <span>Edit</span>
                                  </DropdownItem>
                                </li>

                                
                              </ul>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </li>
                      </ul>
                    </DataTableRow>
                  </DataTableItem>
                ))
              : null}
          </div>
          <PreviewAltCard>
            {data.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={data.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No orders found</span>
              </div>
            )}
          </PreviewAltCard>
        </Block>

        <Modal isOpen={view.add} toggle={() => onFormCancel()} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Add Team</h5>
              <div className="mt-4">
                <form onSubmit={handleSubmit(onFormSubmit)}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                           Name
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="customer"
                            onChange={(e) => onInputChange(e)}
                            ref={register({
                              required: "This field is required",
                            })}
                            defaultValue={formData.customer}
                          />
                          {errors.customer && <span className="invalid">{errors.customer.message}</span>}
                        </div>
                      </div>
                    </Col>
            
                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="email_id">
                          Email
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="email_id"
                            ref={register({ required: "This is required" })}
                            defaultValue={formData.email_id}
                          />
                          {errors.email_id && <span className="invalid">{errors.email_id.message}</span>}
                        </div>
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="phone_no">
                          Phone Number
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="phone_no"
                            ref={register({ required: "This is required" })}
                            defaultValue={formData.phone_no}
                          />
                          {errors.phone_no && <span className="invalid">{errors.phone_no.message}</span>}
                        </div>
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="username">
                          Username
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="username"
                            ref={register({ required: "This is required" })}
                            defaultValue={formData.username}
                          />
                          {errors.username && <span className="invalid">{errors.username.message}</span>}
                        </div>
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="password">
                          Password
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="password"
                            className="form-control"
                            autoComplete="off"
                            name="password"
                            ref={register({ required: "This is required" })}
                            defaultValue={formData.password}
                          />
                          {errors.password && <span className="invalid">{errors.password.message}</span>}
                        </div>
                      </div>
                    </Col>

                    
                    <Row>
                    {stage.length > 0 ? (
                        stage.map((item) => (
                        <div key={item.value + "stage"} className="col-md-6" style={{'display':'flex'}}>
                            <input
                            type="checkbox"
                            className="form-control"
                            value={item.value}
                            id={item.value + "stage"}
                            onChange={handleCheckboxChange}
                            style={{'width':'20px'}}
                            checked={selectedStages.includes(item.value)}
                            />
                            <label htmlFor={item.value + "stage"} style={{'marginBottom':'0px','marginLeft':'10px', 'marginTop':'7px'}}>{item.label}</label>
                        </div>
                        ))
                    ) : (
                        <p>No stages available.</p>
                    )}
                    </Row>

                    <Col size="12">
                      <Button color="primary" disabled={loading} type="submit">
                        <Icon className="plus"></Icon>
                        <span>{loading ? 'Loading...' : 'Add Team'}</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.details} toggle={() => onFormCancel()} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="nk-tnx-details mt-sm-3">
              <div className="nk-modal-head mb-3">
                <h5 className="title">Order Details</h5>
              </div>
              <Row className="gy-3">
                <Col lg={6}>
                  <span className="sub-text">Order Id</span>
                  <span className="caption-text">{formData.orderId}</span>
                </Col>
                <Col lg={6}>
                  <span className="sub-text">Status</span>
                  <span
                    className={`dot bg-${formData.status === "Delivered" ? "success" : "warning"} d-mb-none`}
                  ></span>
                  <span
                    className={`badge badge-sm badge-dot has-bg badge-${
                      formData.status === "Delivered" ? "success" : "warning"
                    } d-none d-mb-inline-flex`}
                  >
                    {formData.status}
                  </span>
                </Col>
                <Col lg={6}>
                  <span className="sub-text">Customer</span>
                  <span className="caption-text">{formData.customer}</span>
                </Col>
                <Col lg={6}>
                  <span className="sub-text">Purchased Product</span>
                  <span className="caption-text">{formData.purchased}</span>
                </Col>
                <Col lg={6}>
                  <span className="sub-text">Total Price</span>
                  <span className="caption-text">{formData.total}</span>
                </Col>
              </Row>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default Teamlist;
